import { render, staticRenderFns } from "./SubscriptionItemView.vue?vue&type=template&id=40d1b533&scoped=true&"
import script from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionItemView.vue?vue&type=style&index=0&id=40d1b533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1b533",
  null
  
)

export default component.exports